import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { db_tables } from '@app/consts';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { SelectSecurityRoleDialogComponent } from './components/select-security-role-dialog/select-security-role-dialog.component';
import { SecurityRole } from '@app/modules/security-setup/models/security-role.model';

@Component({
  selector: 'app-security-role-form-field',
  templateUrl: './security-role-form-field.component.html',
  styleUrls: ['./security-role-form-field.component.scss']
})
export class SecurityRoleFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  public db_tables = db_tables;
  isLoading: boolean;
  items: SecurityRole[] = []
  clearSelectedItems: boolean = false;
  searchValue: string;
  searchFilterString: string;
  getUsersRequest: any;
  selectItemsDialogRef: MatDialogRef<SelectSecurityRoleDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private ngZone: NgZone,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    if (this.parentGroup.controls[this.formElement.formControl].value !== null && this.parentGroup.controls[this.formElement.formControl].value !== undefined) {
      this.items = this.parentGroup.controls[this.formElement.formControl].value;
    }
  }

  showAddModal() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      nonSelectableItems: [...this.items],
      selectableMode: this.formElement.selectableMode || 'single',
    };

    this.ngZone.runOutsideAngular(() => {
      this.selectItemsDialogRef = this.dialog.open(SelectSecurityRoleDialogComponent, dialogConfig);
    });

    const sub = this.selectItemsDialogRef.componentInstance.emitSelectedSecurityRoles.subscribe((event) => {
      this.addItems(event)
    });
  }

  addItems(selectedItems: any) {
    this.items = [...selectedItems];

    this.setFormValue()

    this.selectItemsDialogRef.close();
  }

  deleteAllSelected(itemsToDelete: SecurityRole[]) {
    this.items = this.items.filter(data => !itemsToDelete.includes(data))
    this.setFormValue();
    this.clearSelectedItems = !this.clearSelectedItems;
  }

  setFormValue() {
    this.parentGroup.controls[this.formElement.formControl].setValue(this.items)
  }
}